webpackJsonp([30,21],{

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormError_vue__ = __webpack_require__(189);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dc19256_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormError_vue__ = __webpack_require__(195);
function injectStyle (ssrContext) {
  __webpack_require__(193)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dc19256_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormError',
  props: {
    message: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(194);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("75a52f96", content, true, {});

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".form-error{background-color:#fae0e5;border:1px solid #ed3a4f;border-radius:4px;text-align:center;padding:8px}.form-error .error-ico{float:left;width:22px}.form-error .error-msg{font-family:ProximanovaRegular;font-size:14px}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/Templates/FormError.vue"],"names":[],"mappings":"AACA,YAAY,yBAAyB,yBAAyB,kBAAkB,kBAAkB,WAAW,CAC5G,AACD,uBAAuB,WAAW,UAAU,CAC3C,AACD,uBAAuB,+BAAiC,cAAc,CACrE","file":"FormError.vue","sourcesContent":["\n.form-error{background-color:#fae0e5;border:1px solid #ed3a4f;border-radius:4px;text-align:center;padding:8px\n}\n.form-error .error-ico{float:left;width:22px\n}\n.form-error .error-msg{font-family:\"ProximanovaRegular\";font-size:14px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-error"},[_c('p',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 255:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADCSURBVGhD7dMtCkJBGIXhUTG5A4PV4CoEwY3YrW5CsJjEpJuymN2AYPHn/cBwkbnm813OAy8Dk+aEKWat+t8zrR5t6UEXmlI6MeJI70YnSqU2IjpQGvEfaiOuNKYU/o2YUAoeocIjVHiECo9Q4REqPEKFR6joxIiwo/QjRvSk5ogbpRoRBhQPbw550YrSmdOdOjFmQR6jyGNUeYwqj1HlMao8RpXHqPIYVW1jlpRObcyZUvods6G0ZrSnNQ3jwkxCKR+8BekpyRbCfQAAAABJRU5ErkJggg=="

/***/ }),

/***/ 256:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADKSURBVGhD7Zg9DkFhEEWfROMnLMIWLEBhIRI6jV5pA9agtgU6m9BZBAoJziReIhJad77ck5xMMt3pJlOZgmi8ZmoWeMUTjmKRkR7e8PHyjGNMRwcvWIekjpngHYuImaFjFJmiYxRxjCqOUcUxqjhGFceo4hhVvsUMMR1zfA8JN5iKNu7wM2SFafgWccAupuBXRLyaUuAIFSJij474N8VH9DEFjlDBESo4QgVHqFBERLDF9BFxI6WPCJp4xNQRNQNc4xJbsTCmSKrqCcyG6SlCIUwXAAAAAElFTkSuQmCC"

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Templates_Loading_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Templates_FormError_vue__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Utility__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_App__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_Content__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_GoogleAnalytics__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PopupResetPassword",
  props: ["closePopupCB", "paymentData"],
  data: function data() {
    return {
      paymentContent: null,
      top: "50%",
      width: "40%",
      header: "Payment",
      price: 0.0,
      taxrate: 0,
      iconArrowDown: __webpack_require__(391),
      iconArrowUp: __webpack_require__(392),
      giftArrowDown: __webpack_require__(255),
      giftArrowUp: __webpack_require__(256),
      showPriceDetail: false,
      showGiftDetail: false,
      giftShareTitle: "Share this movie with love",
      recipientName: null,
      recipientEmail: null,
      recipientCountry: null,
      giftingToOther: null,
      countryList: null,
      showCountryList: false,
      showGiftedInfo: false,
      formError: "",
      coupon: null,
      paymentType: null,
      showCouponInput: true,
      paymentError: null,
      searchCountry: null,
      cardHolderName: null,
      cardNumber: null,
      showCardContainer: false,
      cardMonth: null,
      cardYear: null,
      cardCVV: null,
      rememberMe: false,
      showSuccessPart: false,
      transactionID: null,
      orderID: null,
      payemntInitData: null,
      //
      couponData: null,
      showPaymentButton: true,
      showLoading: false,
      successMessage: null,
      discount: null,
      showProceedButton: false,
      //
      contentPrice: null,
      flagPaypal: false
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1__components_Templates_Loading_vue__["default"],
    FormError: __WEBPACK_IMPORTED_MODULE_3__components_Templates_FormError_vue__["default"]
  },
  watch: {
    paymentError: function paymentError(value) {
      var _this = this;

      if (value) {
        setTimeout(function () {
          _this.paymentError = null;
        }, 5000);
      }
    },
    successMessage: function successMessage(value) {
      var _this2 = this;

      if (value) {
        setTimeout(function () {
          _this2.successMessage = null;
        }, 5000);
      }
    },
    paymentContent: function paymentContent() {
      if (this.paymentContent) {
        this.getContentCurrency();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["AppUser", "AppConfig"])),
  mounted: function mounted() {
    var _this3 = this;

    if (this.paymentData.content) {
      this.paymentContent = this.paymentData.content;
      setTimeout(function () {
        // console.log("done")
        _this3.renderPaypalButton();
        // this.quality('HD');
      }, 1000);
    } else if (this.paymentData.contentid) {
      this.getContent();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["actPaymentInit", "actCheckCoupon", "actGetContent"]), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])(["commitNewTicket"]), {
    actChange: function actChange() {
      this.flagPaypal = true;
      // console.log("this.flagPaypal", this.flagPaypal);
    },
    getContentCurrency: function getContentCurrency() {
      this.contentPrice = this.getContentPrice(this.paymentContent);
      if (this.contentPrice) {
        this.calculatePriceAndTax();
      }
    },
    calculatePriceAndTax: function calculatePriceAndTax() {
      this.price = this.contentPrice.amount / 100;
      this.taxrate = (this.contentPrice.taxrate / 100).toFixed(2);
      // if (contentQuality.currency == 'INR'){
      //   this.taxrate= ((contentQuality[0].taxrate /100) * this.price).toFixed(2)

      // } else{
      //   this.taxrate = (contentQuality[0].amount - (contentQuality[0].amount / (1+ (contentQuality[0].taxrate /100)))).toFixed(2);
      //   this.taxrate = (this.taxrate / 100).toFixed(2)
      //   // this.taxrate = (contentQuality[0].taxrate / 100).toFixed(2);
      // }
      this.accessFee = Number(this.price).toFixed(2);
    },
    proceed: function proceed() {
      var _this4 = this;

      if (this.couponData) {
        var params = {
          amount: this.contentPrice.amount,
          currency: this.contentPrice.currency,
          quality: this.contentPrice.quality,
          paymenttype: "TICKET",
          gwprovider: "PAYPAL",
          contentid: this.paymentContent.contentid
        };
        //
        // params.amount = this.couponData.discountedamount;
        params.couponid = this.couponData.discountid;
        //
        this.showLoading = true;
        this.actPaymentInit(params).then(function (response) {
          _this4.showLoading = false;
          if (response.success) {
            _this4.transactionID = response.success;
            _this4.paymentContent.expiry = response.expiry;
            _this4.paymentContent.poster = _this4.getPoster(_this4.paymentContent, "PORTRAIT");
            _this4.addPurchasedContentToFire(_this4.paymentContent);
            _this4.commitNewTicket(true);
            _this4.showSuccessPart = true;
            //
            var GA = {
              "Event Label": "Success",
              ContentTitle: _this4.paymentContent.title,
              ContentID: _this4.paymentContent.contentid,
              Category: _this4.paymentContent.category,
              Amount: _this4.contentPrice.amount / 100,
              Currency: _this4.contentPrice.currency,
              Quality: _this4.contentPrice.quality,
              GWProvider: "PAYPAL"
            };
            if (_this4.couponData) {
              GA.CouponID = _this4.couponData.discountid;
            }
            GA["Event Label"] = "Success";
            GA.PaymentStatus = "SUCCESS";
            GA.TicketID = _this4.transactionID;
            //
            _this4.TicketPurchaseEvent(GA);
            //
            var paymentdata = {
              contentid: _this4.paymentContent.contentid,
              ticketid: _this4.transactionID,
              ticketprice: _this4.contentPrice.amount,
              expiry: response.expiry
            };
            __WEBPACK_IMPORTED_MODULE_8__main__["EventBus"].$emit("TicketPurchase", paymentdata);
          } else {
            var _GA = {
              "Event Label": "Success",
              ContentTitle: _this4.paymentContent.title,
              ContentID: _this4.paymentContent.contentid,
              Category: _this4.paymentContent.category,
              Amount: _this4.contentPrice.amount / 100,
              Currency: _this4.contentPrice.currency,
              Quality: _this4.contentPrice.quality,
              GWProvider: "PAYPAL"
            };
            if (_this4.couponData) {
              _GA.CouponID = _this4.couponData.discountid;
            }
            _GA["Event Label"] = "Failure";
            _GA.PaymentStatus = "FAILUED";
            _GA.ErrorCode = response.error;
            _GA.ErrorMessage = response.reason ? response.reason : response.message;
            //
            _this4.TicketPurchaseEvent(_GA);
            //
            _this4.paymentError = response.error ? response.message : "Please try again later";
          }
        });
      }
    },
    getContent: function getContent() {
      var _this5 = this;

      this.showLoading = true;
      this.paymentContent = null;
      this.actGetContent(this.paymentData.contentid).then(function (response) {
        _this5.showLoading = false;
        if (response) {
          _this5.paymentContent = response;
          if (_this5.paymentData.coupon) {
            _this5.coupon = _this5.paymentData.coupon;
          }
          setTimeout(function () {
            _this5.renderPaypalButton();
            // this.quality('HD');
          }, 100);
        } else {
          _this5.paymentError = response;
        }
      }).catch(function (error) {
        _this5.paymentError = error.reason;
      });
    },
    quality: function quality(value) {
      var contentQuality = this.paymentContent.price.filter(function (p) {
        return p.quality == value;
      });
      if (contentQuality.length > 0) {
        this.price = contentQuality[0].amount / 100;
        if (contentQuality.currency == "INR") {
          this.taxrate = (contentQuality[0].taxrate / 100 * this.price).toFixed(2);
        } else {
          this.taxrate = (contentQuality[0].amount - contentQuality[0].amount / (1 + contentQuality[0].taxrate / 100)).toFixed(2);
          this.taxrate = (this.taxrate / 100).toFixed(2);
          // this.taxrate = (contentQuality[0].taxrate / 100).toFixed(2);
        }
        this.accessFee = Number(this.price - this.taxrate).toFixed(2);
      }
    },
    renderPaypalButton: function renderPaypalButton() {
      // Render the PayPal button into #paypal-button-container1
      var self = this;
      var data = {};
      if (self.AppConfig.payment.PAYPAL.paypalenv === "sandbox") {
        data.sandbox = self.AppConfig.payment.PAYPAL.paypalclientid;
      } else {
        data.production = self.AppConfig.payment.PAYPAL.paypalclientid;
      }

      var paypal = window.paypal;

      paypal.Button.render({
        locale: "",
        country: "",
        env: self.AppConfig.payment.PAYPAL.paypalenv === "live" || self.AppConfig.payment.PAYPAL.paypalenv === "production" ? "production" : "sandbox",
        client: data,
        // client: { production: 'AY9vfUcWx_EuzIOmiQKkHQYFASJq1Ue7FuCLSxUZQo1hvoX4LXvP8KU0YeiQAqEJxs_3Vq0S9RHFX72s' },
        commit: true,
        style: {
          size: "responsive",
          color: "blue",
          shape: "rect",
          tagline: false,
          label: "paypal",
          response: true
        },
        funding: {
          allowed: [],
          disallowed: [paypal.FUNDING.CARD, paypal.FUNDING.CREDIT]
        },
        // Enable Pay Now checkout flow (optional)

        // Set up a payment
        payment: function payment() {
          self.paymentError = null;
          var params = {};
          //  console.log("contentPriceDetails");
          if (self.contentPrice.currency === "INR" || self.contentPrice.currency === "IDR" || self.contentPrice.currency === "VND") {
            params.fallback_currency = "INR";
          }
          params.amount = self.contentPrice.amount;
          params.currency = self.contentPrice.currency;
          params.quality = self.contentPrice.quality;
          params.paymenttype = "TICKET";
          params.gwprovider = "PAYPAL";
          params.contentid = self.paymentContent.contentid;
          // console.log("paypal params", params);
          if (self.couponData && self.couponData.discountedamount) {
            // params.amount = self.couponData.discountedamount
            params.couponid = self.couponData.discountid;
          }

          params.intent = "sale";
          params.payer = {
            payment_method: "paypal"
          };
          params.application_context = {
            shipping_preference: "NO_SHIPPING"
          };

          return self.actPaymentInit(params).then(function (response) {
            // console.log("paypal response", response);
            if (response.success) {
              self.payemntInitData = response;
              return self.payemntInitData.payload.paypalorder.id;
            } else {
              self.paymentError = response ? response.reason : "Please try again later";
              return;
            }
          }).catch(function (error) {
            if (error.status === 401) {
              self.formError = "Session Expired.Please try again later";
              self.sessionExpiredCB();
              __WEBPACK_IMPORTED_MODULE_8__main__["EventBus"].$emit("logOut");
              // window.location.reload()
              self.$router.push({ name: "Home" });
            }
          });
        },
        // Execute the payment
        onAuthorize: function onAuthorize(data, actions) {
          //  console.log("onAuthorize", data);
          self.paymentCallback(data, "SUCCESS");
        },
        onCancel: function onCancel(data, actions) {
          //  console.log("onCancel", data);
          self.paymentCallback(data, "CANCELLED");
        }
        // onError: function(err) {
        //   console.log("onError", err);
        //   if (
        //     err.message !== "Can not open popup window - blocked" &&
        //     err.message !== "No response from window - cleaned up"
        //   ) {
        //     self.paymentCallback(err, "FAILED");
        //   }
        //   // Show an error page here, when an error occurs
        // }
      }, "#paypal-button-container1");
    },
    paymentCallback: function paymentCallback(res, status) {
      var _this6 = this;

      var url = this.payemntInitData.payload.confirmurl;
      this.showLoading = true;
      this.showPaymentButton = false;

      var form = new FormData();
      form.append("reference_id", this.payemntInitData.payload.order_id);
      if (status === "SUCCESS") form.append("orderid", this.payemntInitData.payload.paypalorder.id);
      form.append("status", status);

      fetch(url, {
        method: "POST",
        mimeType: "multipart/form-data",
        body: form
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        _this6.showLoading = false;
        _this6.showPaymentButton = true;
        // console.log("paymentCallback", data);
        var GA = {
          "Event Label": "Success",
          ContentTitle: _this6.paymentContent.title,
          ContentID: _this6.paymentContent.contentid,
          Category: _this6.paymentContent.category,
          Amount: _this6.contentPrice.amount / 100,
          Currency: _this6.contentPrice.currency,
          Quality: _this6.contentPrice.quality,
          GWProvider: "PAYPAL"
        };
        if (_this6.couponData) {
          GA.CouponID = _this6.couponData.discountid;
        }
        if (status === "SUCCESS" && data.success) {
          // console.log("Success", data.success, data.expiry);
          GA["Event Label"] = "Success";
          GA.PaymentStatus = "SUCCESS";
          GA.TicketID = _this6.payemntInitData.payload.paypalorder.id;
          _this6.TicketPurchaseEvent(GA);
          _this6.transactionID = data.success;
          _this6.paymentContent.expiry = data.expiry;
          _this6.orderID = _this6.payemntInitData.payload.paypalorder.id;
          _this6.paymentContent.poster = _this6.getPoster(_this6.paymentContent, "PORTRAIT");
          _this6.addPurchasedContentToFire(_this6.paymentContent);
          _this6.commitNewTicket(true);
          // console.log("Success----------", data.success, data.expiry);
          _this6.showSuccessPart = true;
          //
          var paymentData = {
            contentid: _this6.paymentContent.contentid,
            ticketid: _this6.transactionID,
            ticketprice: _this6.contentPrice.amount,
            expiry: data.expiry
          };
          __WEBPACK_IMPORTED_MODULE_8__main__["EventBus"].$emit("TicketPurchase", paymentData);
        } else if (status === "CANCELLED") {
          GA["Event Label"] = "Failure";
          GA.PaymentStatus = "CANCELLED";
          GA.TicketID = _this6.payemntInitData.payload.paypalorder.id;
          //
          _this6.TicketPurchaseEvent(GA);
          //
          setTimeout(function () {
            _this6.renderPaypalButton();
          }, 100);
          _this6.paymentError = "Payment cancelled";
        } else if (status === "FAILED") {
          // GA['Event Label'] = 'Failure'
          // GA.PaymentStatus = 'FAILED'
          // GA.TicketID = this.payemntInitData.payload.paypalorder.id
          // //
          // this.TicketPurchaseEvent(GA)
          //
          setTimeout(function () {
            _this6.renderPaypalButton();
          }, 100);
          _this6.paymentError = "Payment FAILED.Please try again later";
        } else if (data.error) {
          GA["Event Label"] = "Failure";
          GA.PaymentStatus = "FAILED";
          GA.TicketID = _this6.payemntInitData.payload.paypalorder.id;
          GA.ErrorCode = data.error;
          GA.ErrorMessage = data.reason;
          //
          _this6.TicketPurchaseEvent(GA);
          //
          setTimeout(function () {
            _this6.renderPaypalButton();
          }, 100);
          _this6.paymentError = data.error ? data.reason : "Please try again later";
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _this6.formError = "Session Expired.Please try again later";
          _this6.sessionExpiredCB();
          __WEBPACK_IMPORTED_MODULE_8__main__["EventBus"].$emit("logOut");
          // window.location.reload()
          _this6.$router.push({ name: "Home" });
        }
      });
    },
    getPoster: function getPoster(content, type) {
      if (content.posters.length) {
        var landscapeposters = content.posters.filter(function (pos) {
          return pos.orientation === type;
        });
        if (landscapeposters.length) {
          var posterIndex = landscapeposters.findIndex(function (pos) {
            return pos.quality === "HD";
          });
          if (posterIndex > -1) {
            return landscapeposters[posterIndex].url;
          } else {
            return landscapeposters[0].url;
          }
        }
      }
    },
    completePurchase: function completePurchase() {
      this.showSuccessPart = true;
    },
    removeCoupon: function removeCoupon() {
      var _this7 = this;

      // console.log("------")
      this.coupon = "";
      this.couponData = null;
      this.showCouponInput = true;
      // this.quality('HD');
      this.calculatePriceAndTax();
      this.discount = null;
      this.showPaymentButton = true;
      if (this.showProceedButton) {
        setTimeout(function () {
          _this7.renderPaypalButton();
        }, 100);
      }
      this.showProceedButton = false;
    },
    verifyCoupon: function verifyCoupon() {
      var _this8 = this;

      if (!this.coupon) {
        this.paymentError = "Please enter coupon";
        return;
      }
      this.paymentError = null;
      this.showCouponInput = false;
      //
      var data = {
        quality: this.contentPrice.quality,
        couponid: this.coupon,
        gwprovider: "PAYPAL",
        contentid: this.paymentContent.contentid,
        currency: this.contentPrice.currency
      };
      //
      this.showLoading = true;
      this.actCheckCoupon(data).then(function (response) {
        _this8.showLoading = false;
        // console.log("actCheckCoupon", response);
        if (!response.error) {
          //
          var GA = {
            "Event Label": "Success",
            ContentTitle: _this8.paymentContent.title,
            ContentID: _this8.paymentContent.contentid,
            Category: _this8.paymentContent.category,
            Currency: _this8.contentPrice.currency,
            GWProvider: "PAYPAL",
            CouponID: response.discountid
          };
          // this.CouponClaimEvent(GA);
          //
          _this8.couponData = response;
          if (_this8.couponData.discountedamount > 0) {
            // this.taxrate = (this.couponData.discountedamount - (this.couponData.discountedamount / (1+ (this.contentPrice.taxrate /100)))).toFixed(2);
            // this.taxrate = (this.contentPrice.taxrate / 100).toFixed(2)
            // console.log('discountedamount', this.taxrate)
            // this.price = ((this.couponData.discountedamount - this.taxrate) / 100).toFixed(2)
            // console.log('discountedPrice', this.price)
            // this.discount = (this.couponData.totaldiscount / 100).toFixed(2)
            // this.successMessage = 'Coupon Added Successfully.'
            // console.log('accessFee', ((this.couponData.price - this.couponData.discountedamount) / 100))

            // this.accessFee = ((this.couponData.price - this.couponData.discountedamount) / 100).toFixed(2)

            // let temp = (this.couponData.price / 100 - this.taxrate).toFixed(
            //   2
            // ); // 155.82
            var temp = (_this8.couponData.price / 100).toFixed(2);
            // console.log("temp", temp);

            var contentPrice = Number(temp) + Number(_this8.taxrate); //155.82+3.18
            // console.log("contentPrice", contentPrice);
            // console.log(
            //   "topay",
            //   (Number(this.couponData.price) -
            //     Number(this.couponData.discountedamount)) /
            //     100
            // );
            var topay = (Number(_this8.couponData.discountedamount) / 100).toFixed(2);
            // console.log("topay", topay);

            _this8.price = topay;
            _this8.discount = (_this8.couponData.totaldiscount / 100).toFixed(2);
            _this8.accessFee = temp;
            //
            GA.Amount = _this8.couponData.discountedamount / 100;
            _this8.CouponClaimEvent(GA);
          } else if (_this8.couponData.discountedamount == 0) {
            _this8.price = 0 .toFixed(2);
            _this8.taxrate = 0 .toFixed(2);
            _this8.accessFee = (_this8.couponData.price / 100).toFixed(2);
            _this8.discount = (_this8.couponData.totaldiscount / 100).toFixed(2);
            _this8.showPaymentButton = false;
            _this8.showProceedButton = true;
            _this8.successMessage = "Coupon Added Successfully.";
            //
            GA.Amount = _this8.contentPrice.amount / 100;
            _this8.CouponClaimEvent(GA);
          }
        } else {
          //
          _this8.paymentError = response.reason;
          _this8.removeCoupon();
          //
          var Analytics = {
            "Event Label": "Failure",
            ContentTitle: _this8.paymentContent.title,
            ContentID: _this8.paymentContent.contentid,
            Category: _this8.paymentContent.category,
            Amount: _this8.contentPrice.amount,
            Currency: _this8.contentPrice.currency,
            // GWProvider: "PAYTM",
            ErrorMessage: response.reason,
            ErrorCode: response.error
          };
          _this8.CouponClaimEvent(Analytics);
        }
      }).catch(function (error) {});
    },
    togglePriceMenu: function togglePriceMenu() {
      var elment = document.getElementById("pricearrow");
      if (elment) {
        elment.src = this.showPriceDetail ? this.iconArrowDown : this.iconArrowUp;
      }
      this.showPriceDetail = !this.showPriceDetail;
    }
  }),
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_App__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_Content__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_Utility__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_GoogleAnalytics__["a" /* default */]]
});

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__ = __webpack_require__(322);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eba1bad0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__ = __webpack_require__(393);
function injectStyle (ssrContext) {
  __webpack_require__(389)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eba1bad0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eba1bad0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(390);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("c4e3c89e", content, true, {});

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".textCenter[data-v-eba1bad0]{text-align:center}.payment-popup[data-v-eba1bad0]{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.7);z-index:8888}.payment-popup .popup-box[data-v-eba1bad0]{position:fixed;background-color:#fff;z-index:8889;border-radius:4px;min-width:320px;top:45%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.payment-popup .popup-form[data-v-eba1bad0]{margin-top:10px}.payment-popup .box-header[data-v-eba1bad0]{padding:15px;-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.2);box-shadow:0 1px 4px 0 rgba(0,0,0,.2)}.payment-popup .box-header h6[data-v-eba1bad0]{text-align:center;width:100%;float:left;font-style:normal;color:#212121;font-size:22px;font-family:ProximanovaBold}.payment-popup .header-close[data-v-eba1bad0]{position:absolute;cursor:pointer;float:right;width:34px;top:12px;right:2%;opacity:.7}.payment-popup .header-close[data-v-eba1bad0]:hover{opacity:1}.payment-popup .popup-message[data-v-eba1bad0]{text-align:center;margin:1em;display:block}.session-exp-popup[data-v-eba1bad0]{padding:5%;margin-right:5px}.session-exp-popup[data-v-eba1bad0]::-webkit-scrollbar{width:8px}.session-exp-popup[data-v-eba1bad0]::-webkit-scrollbar-track{border-radius:5px}.session-exp-popup[data-v-eba1bad0]::-webkit-scrollbar-thumb{background:#b9bcb9;border-radius:5px}.summary[data-v-eba1bad0]{color:#212121;font-family:ProximanovaBold;font-size:18px;line-height:29px;font-style:normal}.movie-details[data-v-eba1bad0]{margin-top:10px}.movie-details .movie-title[data-v-eba1bad0]{color:rgba(33,33,33,.8);font-family:ProximanovaSemibold;font-size:20px;line-height:29px;font-style:normal}.movie-details .movie-status[data-v-eba1bad0]{text-transform:uppercase;color:rgba(33,33,33,.9);font-family:HelveticaNeueMedium;font-size:16px;line-height:23px}.movie-details .movie-status span[data-v-eba1bad0]{font-weight:700}.subs-quality[data-v-eba1bad0]{margin:10px 0}.subs-quality .gender-label[data-v-eba1bad0]{display:inline-block;margin-right:10px;color:#212121;font-family:HelveticaNeueMedium;font-size:20px;line-height:22px}.subs-quality label[data-v-eba1bad0]{color:#212121;font-family:HelveticaNeueMedium;font-size:16px;line-height:22px;cursor:pointer}.vlt-radio[data-v-eba1bad0]{position:relative}.vlt-radio.inline[data-v-eba1bad0]{display:inline-block;margin-right:15px}.vlt-radio input[data-v-eba1bad0]{opacity:0;position:absolute}.vlt-radio input:checked+label[data-v-eba1bad0]:after{width:7px;height:7px;left:4px;top:6px;border-radius:50%;background-color:#000}.vlt-radio input:checked+label[data-v-eba1bad0]{font-weight:600!important}.vlt-radio label[data-v-eba1bad0]{position:relative;padding-left:20px;font-weight:300}.vlt-radio label[data-v-eba1bad0]:after,.vlt-radio label[data-v-eba1bad0]:before{position:absolute;content:\"\"}.vlt-radio label[data-v-eba1bad0]:before{width:15px;height:15px;border-radius:50%;left:0;top:2px;border:2px solid #fff;border-color:#000}.price[data-v-eba1bad0]{margin:10px 0}.price p[data-v-eba1bad0]{color:#212121;font-family:ProximanovaRegular;font-size:18px;line-height:22px;float:right;margin-left:0}.price p span[data-v-eba1bad0]{color:#212121;font-family:ProximanovaBold;font-size:24px;line-height:22px;font-weight:700}.price-info[data-v-eba1bad0]{color:#000;float:right}.price-info img[data-v-eba1bad0]{width:18px;opacity:.8}.price-info img[data-v-eba1bad0]:hover{opacity:1}.slide-enter-active[data-v-eba1bad0]{-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-timing-function:ease-in;transition-timing-function:ease-in}.slide-leave-active[data-v-eba1bad0]{-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-timing-function:ease-out;transition-timing-function:ease-out}.slide-enter-to[data-v-eba1bad0],.slide-leave[data-v-eba1bad0]{max-height:100px;overflow:hidden}.slide-enter[data-v-eba1bad0],.slide-leave-to[data-v-eba1bad0]{overflow:hidden;max-height:0}.price-detail[data-v-eba1bad0]{margin-left:0;margin-right:0}.amount-label[data-v-eba1bad0],.amount-style[data-v-eba1bad0]{color:#70787f;font-family:ProximanovaRegular;font-size:18px;line-height:22px;margin:8px 0}.amount-style[data-v-eba1bad0]{text-align:center}.mlmr0[data-v-eba1bad0]{margin-left:0;margin-right:0}.plpr0[data-v-eba1bad0]{padding-left:0;padding-right:0}.gift-container[data-v-eba1bad0]{margin:20px 0;min-height:90px;padding:15px;-webkit-box-shadow:0 0 10px rgba(0,0,0,.25),0 2px 5px rgba(0,0,0,.22);box-shadow:0 0 10px rgba(0,0,0,.25),0 2px 5px rgba(0,0,0,.22)}.gift-container .gift .small[data-v-eba1bad0]{text-align:center}.gift-container .gift-share-title[data-v-eba1bad0]{color:rgba(33,33,33,.8);font-family:HelveticaNeueMedium;font-size:20px;font-weight:700;line-height:25px;text-transform:uppercase;margin-top:5%;text-align:center}.gift-container .gift-arrow[data-v-eba1bad0]{width:25px;margin-top:18%;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);cursor:pointer}.gift-container .gift-detail-open[data-v-eba1bad0]{text-align:start!important;margin-top:3%;font-weight:500!important}.gift-container .gift-detail[data-v-eba1bad0]{margin:10px 0}.gift-container .gift-detail .recipient-label[data-v-eba1bad0]{color:#212121;font-family:HelveticaNeueMedium;font-size:14px;line-height:16px;text-shadow:1px 1px #fff}.gift-container .gift-detail .recipient-input[data-v-eba1bad0]{border-bottom:.5px solid grey}.gift-container .gift-detail .vlt-input-group[data-v-eba1bad0]{margin:15px 0}.gift-container .your-gifting[data-v-eba1bad0]{text-transform:uppercase;color:rgba(33,33,33,.8);font-family:HelveticaNeueMedium;font-size:20px;font-weight:700;line-height:25px;width:300px;margin-top:8%}.gift-container .gift-edit[data-v-eba1bad0]{text-align:end;color:#dc4255}.gift-container .gift-edit[data-v-eba1bad0],.gift-container .gift-remove[data-v-eba1bad0]{cursor:pointer;text-transform:uppercase;font-family:HelveticaNeueMedium;font-size:16px;font-weight:500;line-height:19px;margin-top:10px}.gift-container .gift-remove[data-v-eba1bad0]{color:rgba(33,33,33,.8)}.country .country-name[data-v-eba1bad0]{float:left}.country .selected-country[data-v-eba1bad0]{min-height:30px}.country .selected-country img[data-v-eba1bad0]{width:25px}.country .selected-country p[data-v-eba1bad0]{color:#212121;font-family:HelveticaNeueMedium;font-size:14px;font-weight:500;line-height:17px}.country #countryArrow[data-v-eba1bad0]{width:20px;position:absolute;right:0;top:0;cursor:pointer}.country .country-list[data-v-eba1bad0]{max-height:200px;z-index:100;width:230px;overflow:auto;position:relative;background:#fff;color:#212121;margin-left:-15px;-webkit-box-shadow:0 0 1px rgba(76,86,103,.25),0 2px 18px rgba(31,37,50,.32);box-shadow:0 0 1px rgba(76,86,103,.25),0 2px 18px rgba(31,37,50,.32)}.country .country-list div.plpr0[data-v-eba1bad0]{margin:5px 0;cursor:pointer}.country .country-list div.plpr0 p[data-v-eba1bad0]{margin-top:5px}.country .country-list div.plpr0[data-v-eba1bad0]:hover{background-color:#212121;color:#fff}.country .country-list div.plpr0 img[data-v-eba1bad0]{width:30px}.coupon-container[data-v-eba1bad0]{border:1px solid #bfbfbf;border-radius:6px;padding:5px 15px;margin:20px 0}.coupon-container .coupon[data-v-eba1bad0]{border:0;font-size:22px;min-height:30px;width:100%;background-color:transparent;color:#000;margin-top:5px;word-break:break-word}.coupon-container .coupon[data-v-eba1bad0]::-webkit-input-placeholder{opacity:.4;color:#000;font-family:ProximanovaSemibold;font-size:22px;font-weight:500;line-height:34px}.coupon-container .coupon[data-v-eba1bad0]:-ms-input-placeholder,.coupon-container .coupon[data-v-eba1bad0]::-ms-input-placeholder{opacity:.4;color:#000;font-family:ProximanovaSemibold;font-size:22px;font-weight:500;line-height:34px}.coupon-container .coupon[data-v-eba1bad0]::placeholder{opacity:.4;color:#000;font-family:ProximanovaSemibold;font-size:22px;font-weight:500;line-height:34px}.coupon-container .apply[data-v-eba1bad0]{text-transform:uppercase;color:#4558dd;font-family:ProximanovaBold;font-size:22px;font-weight:700;line-height:34px;cursor:pointer;margin-top:5px;text-align:end;opacity:.85}.coupon-container .apply[data-v-eba1bad0]:hover{opacity:1}.payment-container .pay-using[data-v-eba1bad0]{text-transform:uppercase;margin-bottom:20px;color:rgba(33,33,33,.9);font-family:HelveticaNeueMedium;font-size:24px;line-height:29px}.payment-container .payment-type-image[data-v-eba1bad0]{margin:0 15px -5px}.card-container input[type=number].card-number[data-v-eba1bad0]::-webkit-inner-spin-button,.card-container input[type=number].card-number[data-v-eba1bad0]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.card-container input[type=number].card-number[data-v-eba1bad0]{-moz-appearance:textfield}.card-container .card-input[data-v-eba1bad0]{color:#212121;font-family:HelveticaNeueMedium;font-size:16px;border:0;height:40px;width:100%;border-bottom:1.2px solid #b5b5b5;background-color:transparent;margin-bottom:20px}.card-container .card-input[data-v-eba1bad0]::-webkit-input-placeholder{font-size:16px;color:#212121;font-family:HelveticaNeueMedium}.card-container .card-input[data-v-eba1bad0]:-ms-input-placeholder,.card-container .card-input[data-v-eba1bad0]::-ms-input-placeholder{font-size:16px;color:#212121;font-family:HelveticaNeueMedium}.card-container .card-input[data-v-eba1bad0]::placeholder{font-size:16px;color:#212121;font-family:HelveticaNeueMedium}.card-container .card-mmyy[data-v-eba1bad0]{width:40px;letter-spacing:10px}.card-container .card-mmyy[data-v-eba1bad0]::-webkit-input-placeholder{letter-spacing:2px}.card-container .card-mmyy[data-v-eba1bad0]:-ms-input-placeholder,.card-container .card-mmyy[data-v-eba1bad0]::-ms-input-placeholder{letter-spacing:2px}.card-container .card-mmyy[data-v-eba1bad0]::placeholder{letter-spacing:2px}.card-container .card-cvv[data-v-eba1bad0]{width:50px;letter-spacing:5px}.vlt-checkbox .container[data-v-eba1bad0]{display:block;padding-left:0;cursor:pointer;color:#212121;font-family:HelveticaNeueMedium;font-size:16px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.vlt-checkbox .container input[data-v-eba1bad0]{position:absolute;opacity:0;cursor:pointer;height:0;width:0}.vlt-checkbox .checkmark[data-v-eba1bad0]{position:absolute;top:0;left:0;height:20px;width:20px;background-color:#fff;border:1px solid #000;border-radius:4px}.vlt-checkbox .container:hover input~.checkmark[data-v-eba1bad0],.vlt-checkbox .container input:checked~.checkmark[data-v-eba1bad0]{background-color:#fff}.vlt-checkbox .checkmark[data-v-eba1bad0]:after{content:\"\";position:absolute;display:none}.vlt-checkbox .container input:checked~.checkmark[data-v-eba1bad0]:after{display:block}.vlt-checkbox .container .checkmark[data-v-eba1bad0]:after{left:7px;top:1px;width:8px;height:13px;border:solid #000;border-width:0 3px 3px 0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.payment-success[data-v-eba1bad0]{color:#1b1b1b;font-family:ProximanovaSemibold;font-size:22px;font-weight:700;margin:2% 20%;text-align:center}.success-info p[data-v-eba1bad0]{color:#212121;font-family:ProximanovaRegular;font-size:16px}.amount-info .doller[data-v-eba1bad0]{color:rgba(33,33,33,.9);font-family:ProximanovaRegular;font-size:24px;margin-right:5px}.amount-info p[data-v-eba1bad0]{margin:5px 0}.amount-info p[data-v-eba1bad0]:first-child{margin:10px 0}.amount-recived[data-v-eba1bad0]{color:rgba(33,33,33,.9);font-family:ProximanovaBold;font-size:20px;font-weight:700;line-height:29px}.transactionandorderid[data-v-eba1bad0]{opacity:.6;color:#212121;font-family:ProximanovaRegular;font-size:16px;font-weight:500;line-height:24px}.success-price[data-v-eba1bad0]{color:#212121;font-family:ProximanovaBold;font-size:26px;font-weight:700;line-height:41px}.purchased-content[data-v-eba1bad0]{color:rgba(33,33,33,.9);font-family:HelveticaNeueMedium;font-size:24px;font-weight:700;line-height:29px;text-transform:uppercase;margin:0 0 10px}.after-success[data-v-eba1bad0]{color:#212121;text-align:end;font-family:HelveticaNeueMedium}.after-success span[data-v-eba1bad0]{color:#d0021b;font-size:12px;font-weight:700;line-height:19px}.succes-movie-title[data-v-eba1bad0]{color:rgba(33,33,33,.9);font-family:HelveticaNeueMedium;font-size:18px;font-weight:700;line-height:23px}.purchased-content-image[data-v-eba1bad0]{margin-bottom:5%}.purchased-content-image div.outer[data-v-eba1bad0]{margin-top:5%;height:100%;text-align:center}.purchased-content-image div.outer img.contentImage[data-v-eba1bad0]{border-radius:5px;width:22%}.purchased-content-image p[data-v-eba1bad0]{color:#70787f;font-family:ProximanovaSemibold;font-size:16px;font-weight:700;text-align:center}.play[data-v-eba1bad0]{width:50px;position:relative;top:45%;left:45%}.quality-radio[data-v-eba1bad0]{margin-right:10px!important}.header-success-close[data-v-eba1bad0]{float:right;width:30px;cursor:pointer}.hrline[data-v-eba1bad0]{margin:3% 0;border-bottom:1px solid #acacac}.purchaseBtn .logo-container[data-v-eba1bad0]{background:#fff;padding:10px;width:30%;float:left;margin-left:5%;margin-right:4%}.purchaseBtn p[data-v-eba1bad0]{font-family:ProximanovaSemibold;font-size:22px;float:left;font-weight:700;margin-top:15px}.purchase-success[data-v-eba1bad0]{width:30px!important;height:30px!important;float:right;position:absolute;left:56%;margin-top:-10px;background-color:#6ac259;border-radius:50%}.purchase-success img[data-v-eba1bad0]{width:80%;margin-top:10%}.success-message[data-v-eba1bad0]{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6;border-radius:4px;text-align:center;padding:8px;margin-top:20px}.success-message p[data-v-eba1bad0]{font-size:20px}@media only screen and (max-width:576px){.payment-popup .popup-box[data-v-eba1bad0]{min-width:250px}.payment-popup .box-header[data-v-eba1bad0]{padding:10px}.payment-popup .box-header h6[data-v-eba1bad0]{font-size:20px}.coupon-container[data-v-eba1bad0]{border:1px solid #bfbfbf;border-radius:6px;padding:5px 15px;margin:20px 0}.coupon-container .coupon[data-v-eba1bad0]{border:0;font-size:22px;min-height:30px;width:130%;background-color:transparent;color:#000;margin-top:5px;word-break:break-word}.coupon-container .coupon[data-v-eba1bad0]::-webkit-input-placeholder{opacity:.4;color:#000;font-family:ProximanovaSemibold;font-size:22px;font-weight:500;line-height:34px}.coupon-container .coupon[data-v-eba1bad0]:-ms-input-placeholder,.coupon-container .coupon[data-v-eba1bad0]::-ms-input-placeholder{opacity:.4;color:#000;font-family:ProximanovaSemibold;font-size:22px;font-weight:500;line-height:34px}.coupon-container .coupon[data-v-eba1bad0]::placeholder{opacity:.4;color:#000;font-family:ProximanovaSemibold;font-size:22px;font-weight:500;line-height:34px}.coupon-container .apply[data-v-eba1bad0]{text-transform:uppercase;color:#4558dd;font-family:ProximanovaBold;font-size:22px;font-weight:700;line-height:34px;cursor:pointer;margin-top:5px;text-align:end;opacity:.85}.coupon-container .apply[data-v-eba1bad0]:hover{opacity:1}.payment-success[data-v-eba1bad0]{margin:2% 0;color:#1b1b1b;font-family:ProximanovaSemibold;font-size:18px;font-weight:700;margin:2% 20%;text-align:center}.purchase-success[data-v-eba1bad0]{width:20px!important;height:20px!important}}@media only screen and (min-width:600px) and (max-width:992px){.payment-popup .popup-box[data-v-eba1bad0]{min-width:500px}}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/Popups/Payment.vue"],"names":[],"mappings":"AACA,6BAA6B,iBAAiB,CAC7C,AACD,gCAAgC,eAAe,MAAM,OAAO,WAAW,YAAY,gCAAiC,YAAY,CAC/H,AACD,2CAA2C,eAAe,sBAAsB,aAAa,kBAAkB,gBAAgB,QAAQ,SAAS,uCAAwC,8BAA+B,CACtN,AACD,4CAA4C,eAAe,CAC1D,AACD,4CAA4C,aAAa,8CAA+C,qCAAsC,CAC7I,AACD,+CAA+C,kBAAkB,WAAW,WAAW,kBAAkB,cAAc,eAAe,2BAA6B,CAClK,AACD,8CAA8C,kBAAkB,eAAe,YAAY,WAAW,SAAS,SAAS,UAAW,CAClI,AACD,oDAAoD,SAAS,CAC5D,AACD,+CAA+C,kBAAkB,WAAW,aAAa,CACxF,AACD,oCAAoC,WAAW,gBAAgB,CAC9D,AACD,uDAAuD,SAAS,CAC/D,AACD,6DAA6D,iBAAiB,CAC7E,AACD,6DAA6D,mBAAmB,iBAAiB,CAChG,AACD,0BAA0B,cAAc,4BAA8B,eAAe,iBAAiB,iBAAiB,CACtH,AACD,gCAAgC,eAAe,CAC9C,AACD,6CAA6C,wBAAyB,gCAAkC,eAAe,iBAAiB,iBAAiB,CACxJ,AACD,8CAA8C,yBAAyB,wBAAyB,gCAAkC,eAAe,gBAAgB,CAChK,AACD,mDAAmD,eAAgB,CAClE,AACD,+BAA+B,aAAe,CAC7C,AACD,6CAA6C,qBAAqB,kBAAkB,cAAc,gCAAkC,eAAe,gBAAgB,CAClK,AACD,qCAAqC,cAAc,gCAAkC,eAAe,iBAAiB,cAAc,CAClI,AACD,4BAA4B,iBAAiB,CAC5C,AACD,mCAAmC,qBAAqB,iBAAiB,CACxE,AACD,kCAAkC,UAAU,iBAAiB,CAC5D,AACD,sDAAuD,UAAU,WAAW,SAAS,QAAQ,kBAAkB,qBAAsB,CACpI,AACD,gDAAgD,yBAA0B,CACzE,AACD,kCAAkC,kBAAkB,kBAAkB,eAAe,CACpF,AACD,iFAAmF,kBAAkB,UAAU,CAC9G,AACD,yCAA0C,WAAW,YAAY,kBAAkB,OAAO,QAAQ,sBAAuB,iBAAkB,CAC1I,AACD,wBAAwB,aAAe,CACtC,AACD,0BAA0B,cAAc,+BAAiC,eAAe,iBAAiB,YAAY,aAAc,CAClI,AACD,+BAA+B,cAAc,4BAA8B,eAAe,iBAAiB,eAAgB,CAC1H,AACD,6BAA6B,WAAY,WAAW,CACnD,AACD,iCAAiC,WAAW,UAAW,CACtD,AACD,uCAAuC,SAAS,CAC/C,AACD,qCAAqC,gCAAiC,wBAAyB,2CAA2C,kCAAkC,CAC3K,AACD,qCAAqC,gCAAiC,wBAAyB,4CAA4C,mCAAmC,CAC7K,AACD,+DAA+D,iBAAiB,eAAe,CAC9F,AACD,+DAA+D,gBAAgB,YAAY,CAC1F,AACD,+BAA+B,cAAgB,cAAgB,CAC9D,AAGD,8DAF+B,cAAc,+BAAiC,eAAe,iBAAiB,YAAY,CAGzH,AADD,+BAA4C,iBAAkB,CAC7D,AACD,wBAAwB,cAAc,cAAc,CACnD,AACD,wBAAwB,eAAe,eAAe,CACrD,AACD,iCAAiC,cAAc,gBAAgB,aAAa,sEAA0E,6DAAiE,CACtN,AACD,8CAA8C,iBAAiB,CAC9D,AACD,mDAAmD,wBAAyB,gCAAkC,eAAe,gBAAiB,iBAAiB,yBAAyB,cAAc,iBAAiB,CACtN,AACD,6CAA6C,WAAW,eAAe,iCAAiC,yBAAyB,cAAc,CAC9I,AACD,mDAAmD,2BAA4B,cAAc,yBAA0B,CACtH,AACD,8CAA8C,aAAa,CAC1D,AACD,+DAA+D,cAAc,gCAAkC,eAAe,iBAAiB,wBAA2B,CACzK,AACD,+DAA+D,6BAA8B,CAC5F,AACD,+DAA+D,aAAa,CAC3E,AACD,+CAA+C,yBAAyB,wBAAyB,gCAAkC,eAAe,gBAAiB,iBAAiB,YAAY,aAAa,CAC5M,AACD,4CAA2D,eAAe,AAAyB,aAAc,CAChH,AACD,0FAF4C,eAAe,AAAe,yBAAyB,AAAc,gCAAkC,eAAe,gBAAgB,iBAAiB,eAAe,CAGjN,AADD,8CAAsF,uBAAyB,CAC9G,AACD,wCAAwC,UAAU,CACjD,AACD,4CAA4C,eAAe,CAC1D,AACD,gDAAgD,UAAU,CACzD,AACD,8CAA8C,cAAc,gCAAkC,eAAe,gBAAgB,gBAAgB,CAC5I,AACD,wCAAwC,WAAW,kBAAkB,QAAQ,MAAM,cAAc,CAChG,AACD,wCAAwC,iBAAiB,YAAY,YAAY,cAAc,kBAAkB,gBAAmB,cAAc,kBAAkB,6EAA+E,oEAAsE,CACxT,AACD,kDAAkD,aAAa,cAAc,CAC5E,AACD,oDAAoD,cAAc,CACjE,AACD,wDAAwD,yBAAyB,UAAa,CAC7F,AACD,sDAAsD,UAAU,CAC/D,AACD,mCAAmC,yBAAyB,kBAAkB,iBAAiB,aAAa,CAC3G,AACD,2CAA2C,SAAS,eAAe,gBAAgB,WAAW,6BAA6B,WAAW,eAAe,qBAAqB,CACzK,AACD,sEAAsE,WAAY,WAAW,gCAAkC,eAAe,gBAAgB,gBAAgB,CAC7K,AAGD,mIAAkE,WAAY,WAAW,gCAAkC,eAAe,gBAAgB,gBAAgB,CACzK,AACD,wDAAwD,WAAY,WAAW,gCAAkC,eAAe,gBAAgB,gBAAgB,CAC/J,AACD,0CAA0C,yBAAyB,cAAc,4BAA8B,eAAe,gBAAiB,iBAAiB,eAAe,eAAe,eAAe,WAAY,CACxN,AACD,gDAAgD,SAAS,CACxD,AACD,+CAA+C,yBAAyB,mBAAmB,wBAAyB,gCAAkC,eAAe,gBAAgB,CACpL,AACD,wDAAwD,kBAAkB,CACzE,AACD,sLAA0L,wBAAwB,QAAQ,CACzN,AACD,gEAAkE,yBAAyB,CAC1F,AACD,6CAA6C,cAAc,gCAAkC,eAAe,SAAS,YAAY,WAAW,kCAAkC,6BAA6B,kBAAkB,CAC5N,AACD,wEAAwE,eAAe,cAAc,+BAAiC,CACrI,AAGD,uIAAoE,eAAe,cAAc,+BAAiC,CACjI,AACD,0DAA0D,eAAe,cAAc,+BAAiC,CACvH,AACD,4CAA4C,WAAW,mBAAmB,CACzE,AACD,uEAAuE,kBAAkB,CACxF,AAGD,qIAAmE,kBAAkB,CACpF,AACD,yDAAyD,kBAAkB,CAC1E,AACD,2CAA2C,WAAW,kBAAkB,CACvE,AACD,0CAA0C,cAAc,eAAe,eAAe,cAAc,gCAAkC,eAAe,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CACxO,AACD,gDAAgD,kBAAkB,UAAU,eAAe,SAAS,OAAO,CAC1G,AACD,0CAA0C,kBAAkB,MAAM,OAAO,YAAY,WAAW,sBAAyB,sBAAuB,iBAAiB,CAChK,AAGD,oIAAqE,qBAAwB,CAC5F,AACD,gDAAgD,WAAW,kBAAkB,YAAY,CACxF,AACD,yEAA2E,aAAa,CACvF,AACD,2DAA2D,SAAS,QAAQ,UAAU,YAAY,kBAAmB,yBAAyB,gCAAgC,uBAAuB,CACpM,AACD,kCAAkC,cAAc,gCAAkC,eAAe,gBAAiB,cAAc,iBAAiB,CAChJ,AACD,iCAAiC,cAAc,+BAAiC,cAAc,CAC7F,AACD,sCAAsC,wBAAyB,+BAAiC,eAAe,gBAAgB,CAC9H,AACD,gCAAgC,YAAY,CAC3C,AACD,4CAA6C,aAAa,CACzD,AACD,iCAAiC,wBAAyB,4BAA8B,eAAe,gBAAiB,gBAAgB,CACvI,AACD,wCAAwC,WAAY,cAAc,+BAAiC,eAAe,gBAAgB,gBAAgB,CACjJ,AACD,gCAAgC,cAAc,4BAA8B,eAAe,gBAAiB,gBAAgB,CAC3H,AACD,oCAAoC,wBAAyB,gCAAkC,eAAe,gBAAiB,iBAAiB,yBAAyB,eAAiB,CACzL,AACD,gCAAgC,cAAc,eAAe,+BAAiC,CAC7F,AACD,qCAAqC,cAAc,eAAe,gBAAiB,gBAAgB,CAClG,AACD,qCAAqC,wBAAyB,gCAAkC,eAAe,gBAAiB,gBAAgB,CAC/I,AACD,0CAA0C,gBAAgB,CACzD,AACD,oDAAoD,cAAc,YAAY,iBAAiB,CAC9F,AACD,qEAAqE,kBAAkB,SAAS,CAC/F,AACD,4CAA4C,cAAc,gCAAkC,eAAe,gBAAiB,iBAAiB,CAC5I,AACD,uBAAuB,WAAW,kBAAkB,QAAQ,QAAQ,CACnE,AACD,gCAAgC,2BAA4B,CAC3D,AACD,uCAAuC,YAAY,WAAW,cAAc,CAC3E,AACD,yBAAyB,YAAY,+BAA+B,CACnE,AACD,8CAA8C,gBAAmB,aAAa,UAAU,WAAW,eAAe,eAAe,CAChI,AACD,gCAAgC,gCAAkC,eAAe,WAAW,gBAAiB,eAAe,CAC3H,AACD,mCAAmC,qBAAsB,sBAAuB,YAAY,kBAAkB,SAAS,iBAAiB,yBAAyB,iBAAiB,CACjL,AACD,uCAAuC,UAAU,cAAc,CAC9D,AACD,kCAAkC,cAAc,yBAAyB,qBAAqB,kBAAkB,kBAAkB,YAAY,eAAe,CAC5J,AACD,oCAAoC,cAAc,CACjD,AACD,yCACA,2CAA2C,eAAe,CACzD,AACD,4CAA4C,YAAY,CACvD,AACD,+CAA+C,cAAc,CAC5D,AACD,mCAAmC,yBAAyB,kBAAkB,iBAAiB,aAAa,CAC3G,AACD,2CAA2C,SAAS,eAAe,gBAAgB,WAAW,6BAA6B,WAAW,eAAe,qBAAqB,CACzK,AACD,sEAAsE,WAAY,WAAW,gCAAkC,eAAe,gBAAgB,gBAAgB,CAC7K,AAGD,mIAAkE,WAAY,WAAW,gCAAkC,eAAe,gBAAgB,gBAAgB,CACzK,AACD,wDAAwD,WAAY,WAAW,gCAAkC,eAAe,gBAAgB,gBAAgB,CAC/J,AACD,0CAA0C,yBAAyB,cAAc,4BAA8B,eAAe,gBAAiB,iBAAiB,eAAe,eAAe,eAAe,WAAY,CACxN,AACD,gDAAgD,SAAS,CACxD,AACD,kCAAkC,YAAY,cAAc,gCAAkC,eAAe,gBAAiB,cAAc,iBAAiB,CAC5J,AACD,mCAAmC,qBAAsB,qBAAsB,CAC9E,CACA,AACD,+DACA,2CAA2C,eAAe,CACzD,CACA","file":"Payment.vue","sourcesContent":["\n.textCenter[data-v-eba1bad0]{text-align:center\n}\n.payment-popup[data-v-eba1bad0]{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,0.7);z-index:8888\n}\n.payment-popup .popup-box[data-v-eba1bad0]{position:fixed;background-color:#fff;z-index:8889;border-radius:4px;min-width:320px;top:45%;left:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)\n}\n.payment-popup .popup-form[data-v-eba1bad0]{margin-top:10px\n}\n.payment-popup .box-header[data-v-eba1bad0]{padding:15px;-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,0.2);box-shadow:0 1px 4px 0 rgba(0,0,0,0.2)\n}\n.payment-popup .box-header h6[data-v-eba1bad0]{text-align:center;width:100%;float:left;font-style:normal;color:#212121;font-size:22px;font-family:\"ProximanovaBold\"\n}\n.payment-popup .header-close[data-v-eba1bad0]{position:absolute;cursor:pointer;float:right;width:34px;top:12px;right:2%;opacity:0.7\n}\n.payment-popup .header-close[data-v-eba1bad0]:hover{opacity:1\n}\n.payment-popup .popup-message[data-v-eba1bad0]{text-align:center;margin:1em;display:block\n}\n.session-exp-popup[data-v-eba1bad0]{padding:5%;margin-right:5px\n}\n.session-exp-popup[data-v-eba1bad0]::-webkit-scrollbar{width:8px\n}\n.session-exp-popup[data-v-eba1bad0]::-webkit-scrollbar-track{border-radius:5px\n}\n.session-exp-popup[data-v-eba1bad0]::-webkit-scrollbar-thumb{background:#b9bcb9;border-radius:5px\n}\n.summary[data-v-eba1bad0]{color:#212121;font-family:\"ProximanovaBold\";font-size:18px;line-height:29px;font-style:normal\n}\n.movie-details[data-v-eba1bad0]{margin-top:10px\n}\n.movie-details .movie-title[data-v-eba1bad0]{color:rgba(33,33,33,0.8);font-family:\"ProximanovaSemibold\";font-size:20px;line-height:29px;font-style:normal\n}\n.movie-details .movie-status[data-v-eba1bad0]{text-transform:uppercase;color:rgba(33,33,33,0.9);font-family:\"HelveticaNeueMedium\";font-size:16px;line-height:23px\n}\n.movie-details .movie-status span[data-v-eba1bad0]{font-weight:bold\n}\n.subs-quality[data-v-eba1bad0]{margin:10px 0px\n}\n.subs-quality .gender-label[data-v-eba1bad0]{display:inline-block;margin-right:10px;color:#212121;font-family:\"HelveticaNeueMedium\";font-size:20px;line-height:22px\n}\n.subs-quality label[data-v-eba1bad0]{color:#212121;font-family:\"HelveticaNeueMedium\";font-size:16px;line-height:22px;cursor:pointer\n}\n.vlt-radio[data-v-eba1bad0]{position:relative\n}\n.vlt-radio.inline[data-v-eba1bad0]{display:inline-block;margin-right:15px\n}\n.vlt-radio input[data-v-eba1bad0]{opacity:0;position:absolute\n}\n.vlt-radio input:checked+label[data-v-eba1bad0]::after{width:7px;height:7px;left:4px;top:6px;border-radius:50%;background-color:black\n}\n.vlt-radio input:checked+label[data-v-eba1bad0]{font-weight:600 !important\n}\n.vlt-radio label[data-v-eba1bad0]{position:relative;padding-left:20px;font-weight:300\n}\n.vlt-radio label[data-v-eba1bad0]::before,.vlt-radio label[data-v-eba1bad0]::after{position:absolute;content:\"\"\n}\n.vlt-radio label[data-v-eba1bad0]::before{width:15px;height:15px;border-radius:50%;left:0;top:2px;border:2px solid white;border-color:black\n}\n.price[data-v-eba1bad0]{margin:10px 0px\n}\n.price p[data-v-eba1bad0]{color:#212121;font-family:\"ProximanovaRegular\";font-size:18px;line-height:22px;float:right;margin-left:0%\n}\n.price p span[data-v-eba1bad0]{color:#212121;font-family:\"ProximanovaBold\";font-size:24px;line-height:22px;font-weight:bold\n}\n.price-info[data-v-eba1bad0]{color:black;float:right\n}\n.price-info img[data-v-eba1bad0]{width:18px;opacity:0.8\n}\n.price-info img[data-v-eba1bad0]:hover{opacity:1\n}\n.slide-enter-active[data-v-eba1bad0]{-webkit-transition-duration:0.2s;transition-duration:0.2s;-webkit-transition-timing-function:ease-in;transition-timing-function:ease-in\n}\n.slide-leave-active[data-v-eba1bad0]{-webkit-transition-duration:0.2s;transition-duration:0.2s;-webkit-transition-timing-function:ease-out;transition-timing-function:ease-out\n}\n.slide-enter-to[data-v-eba1bad0],.slide-leave[data-v-eba1bad0]{max-height:100px;overflow:hidden\n}\n.slide-enter[data-v-eba1bad0],.slide-leave-to[data-v-eba1bad0]{overflow:hidden;max-height:0\n}\n.price-detail[data-v-eba1bad0]{margin-left:0px;margin-right:0px\n}\n.amount-label[data-v-eba1bad0]{color:#70787f;font-family:\"ProximanovaRegular\";font-size:18px;line-height:22px;margin:8px 0\n}\n.amount-style[data-v-eba1bad0]{margin:8px 0;text-align:center;color:#70787f;font-family:\"ProximanovaRegular\";font-size:18px;line-height:22px\n}\n.mlmr0[data-v-eba1bad0]{margin-left:0;margin-right:0\n}\n.plpr0[data-v-eba1bad0]{padding-left:0;padding-right:0\n}\n.gift-container[data-v-eba1bad0]{margin:20px 0;min-height:90px;padding:15px;-webkit-box-shadow:0 0px 10px rgba(0,0,0,0.25),0 2px 5px rgba(0,0,0,0.22);box-shadow:0 0px 10px rgba(0,0,0,0.25),0 2px 5px rgba(0,0,0,0.22)\n}\n.gift-container .gift .small[data-v-eba1bad0]{text-align:center\n}\n.gift-container .gift-share-title[data-v-eba1bad0]{color:rgba(33,33,33,0.8);font-family:\"HelveticaNeueMedium\";font-size:20px;font-weight:bold;line-height:25px;text-transform:uppercase;margin-top:5%;text-align:center\n}\n.gift-container .gift-arrow[data-v-eba1bad0]{width:25px;margin-top:18%;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);cursor:pointer\n}\n.gift-container .gift-detail-open[data-v-eba1bad0]{text-align:start !important;margin-top:3%;font-weight:500 !important\n}\n.gift-container .gift-detail[data-v-eba1bad0]{margin:10px 0\n}\n.gift-container .gift-detail .recipient-label[data-v-eba1bad0]{color:#212121;font-family:\"HelveticaNeueMedium\";font-size:14px;line-height:16px;text-shadow:1px 1px #ffffff\n}\n.gift-container .gift-detail .recipient-input[data-v-eba1bad0]{border-bottom:0.5px solid grey\n}\n.gift-container .gift-detail .vlt-input-group[data-v-eba1bad0]{margin:15px 0\n}\n.gift-container .your-gifting[data-v-eba1bad0]{text-transform:uppercase;color:rgba(33,33,33,0.8);font-family:\"HelveticaNeueMedium\";font-size:20px;font-weight:bold;line-height:25px;width:300px;margin-top:8%\n}\n.gift-container .gift-edit[data-v-eba1bad0]{cursor:pointer;text-align:end;text-transform:uppercase;color:#dc4255;font-family:\"HelveticaNeueMedium\";font-size:16px;font-weight:500;line-height:19px;margin-top:10px\n}\n.gift-container .gift-remove[data-v-eba1bad0]{cursor:pointer;text-transform:uppercase;color:rgba(33,33,33,0.8);font-family:\"HelveticaNeueMedium\";font-size:16px;font-weight:500;line-height:19px;margin-top:10px\n}\n.country .country-name[data-v-eba1bad0]{float:left\n}\n.country .selected-country[data-v-eba1bad0]{min-height:30px\n}\n.country .selected-country img[data-v-eba1bad0]{width:25px\n}\n.country .selected-country p[data-v-eba1bad0]{color:#212121;font-family:\"HelveticaNeueMedium\";font-size:14px;font-weight:500;line-height:17px\n}\n.country #countryArrow[data-v-eba1bad0]{width:20px;position:absolute;right:0;top:0;cursor:pointer\n}\n.country .country-list[data-v-eba1bad0]{max-height:200px;z-index:100;width:230px;overflow:auto;position:relative;background:#ffffff;color:#212121;margin-left:-15px;-webkit-box-shadow:0 0 1px rgba(76,86,103,0.25),0 2px 18px rgba(31,37,50,0.32);box-shadow:0 0 1px rgba(76,86,103,0.25),0 2px 18px rgba(31,37,50,0.32)\n}\n.country .country-list div.plpr0[data-v-eba1bad0]{margin:5px 0;cursor:pointer\n}\n.country .country-list div.plpr0 p[data-v-eba1bad0]{margin-top:5px\n}\n.country .country-list div.plpr0[data-v-eba1bad0]:hover{background-color:#212121;color:#ffffff\n}\n.country .country-list div.plpr0 img[data-v-eba1bad0]{width:30px\n}\n.coupon-container[data-v-eba1bad0]{border:1px solid #bfbfbf;border-radius:6px;padding:5px 15px;margin:20px 0\n}\n.coupon-container .coupon[data-v-eba1bad0]{border:0;font-size:22px;min-height:30px;width:100%;background-color:transparent;color:#000;margin-top:5px;word-break:break-word\n}\n.coupon-container .coupon[data-v-eba1bad0]::-webkit-input-placeholder{opacity:0.4;color:#000;font-family:\"ProximanovaSemibold\";font-size:22px;font-weight:500;line-height:34px\n}\n.coupon-container .coupon[data-v-eba1bad0]:-ms-input-placeholder{opacity:0.4;color:#000;font-family:\"ProximanovaSemibold\";font-size:22px;font-weight:500;line-height:34px\n}\n.coupon-container .coupon[data-v-eba1bad0]::-ms-input-placeholder{opacity:0.4;color:#000;font-family:\"ProximanovaSemibold\";font-size:22px;font-weight:500;line-height:34px\n}\n.coupon-container .coupon[data-v-eba1bad0]::placeholder{opacity:0.4;color:#000;font-family:\"ProximanovaSemibold\";font-size:22px;font-weight:500;line-height:34px\n}\n.coupon-container .apply[data-v-eba1bad0]{text-transform:uppercase;color:#4558dd;font-family:\"ProximanovaBold\";font-size:22px;font-weight:bold;line-height:34px;cursor:pointer;margin-top:5px;text-align:end;opacity:0.85\n}\n.coupon-container .apply[data-v-eba1bad0]:hover{opacity:1\n}\n.payment-container .pay-using[data-v-eba1bad0]{text-transform:uppercase;margin-bottom:20px;color:rgba(33,33,33,0.9);font-family:\"HelveticaNeueMedium\";font-size:24px;line-height:29px\n}\n.payment-container .payment-type-image[data-v-eba1bad0]{margin:0 15px -5px\n}\n.card-container input[type=\"number\"].card-number[data-v-eba1bad0]::-webkit-outer-spin-button,.card-container input[type=\"number\"].card-number[data-v-eba1bad0]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0\n}\n.card-container input[type=\"number\"].card-number[data-v-eba1bad0]{-moz-appearance:textfield\n}\n.card-container .card-input[data-v-eba1bad0]{color:#212121;font-family:\"HelveticaNeueMedium\";font-size:16px;border:0;height:40px;width:100%;border-bottom:1.2px solid #b5b5b5;background-color:transparent;margin-bottom:20px\n}\n.card-container .card-input[data-v-eba1bad0]::-webkit-input-placeholder{font-size:16px;color:#212121;font-family:\"HelveticaNeueMedium\"\n}\n.card-container .card-input[data-v-eba1bad0]:-ms-input-placeholder{font-size:16px;color:#212121;font-family:\"HelveticaNeueMedium\"\n}\n.card-container .card-input[data-v-eba1bad0]::-ms-input-placeholder{font-size:16px;color:#212121;font-family:\"HelveticaNeueMedium\"\n}\n.card-container .card-input[data-v-eba1bad0]::placeholder{font-size:16px;color:#212121;font-family:\"HelveticaNeueMedium\"\n}\n.card-container .card-mmyy[data-v-eba1bad0]{width:40px;letter-spacing:10px\n}\n.card-container .card-mmyy[data-v-eba1bad0]::-webkit-input-placeholder{letter-spacing:2px\n}\n.card-container .card-mmyy[data-v-eba1bad0]:-ms-input-placeholder{letter-spacing:2px\n}\n.card-container .card-mmyy[data-v-eba1bad0]::-ms-input-placeholder{letter-spacing:2px\n}\n.card-container .card-mmyy[data-v-eba1bad0]::placeholder{letter-spacing:2px\n}\n.card-container .card-cvv[data-v-eba1bad0]{width:50px;letter-spacing:5px\n}\n.vlt-checkbox .container[data-v-eba1bad0]{display:block;padding-left:0;cursor:pointer;color:#212121;font-family:\"HelveticaNeueMedium\";font-size:16px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none\n}\n.vlt-checkbox .container input[data-v-eba1bad0]{position:absolute;opacity:0;cursor:pointer;height:0;width:0\n}\n.vlt-checkbox .checkmark[data-v-eba1bad0]{position:absolute;top:0;left:0;height:20px;width:20px;background-color:#ffffff;border:1px solid black;border-radius:4px\n}\n.vlt-checkbox .container:hover input ~ .checkmark[data-v-eba1bad0]{background-color:#ffffff\n}\n.vlt-checkbox .container input:checked ~ .checkmark[data-v-eba1bad0]{background-color:#ffffff\n}\n.vlt-checkbox .checkmark[data-v-eba1bad0]:after{content:\"\";position:absolute;display:none\n}\n.vlt-checkbox .container input:checked ~ .checkmark[data-v-eba1bad0]:after{display:block\n}\n.vlt-checkbox .container .checkmark[data-v-eba1bad0]:after{left:7px;top:1px;width:8px;height:13px;border:solid black;border-width:0 3px 3px 0;-webkit-transform:rotate(45deg);transform:rotate(45deg)\n}\n.payment-success[data-v-eba1bad0]{color:#1b1b1b;font-family:\"ProximanovaSemibold\";font-size:22px;font-weight:bold;margin:2% 20%;text-align:center\n}\n.success-info p[data-v-eba1bad0]{color:#212121;font-family:\"ProximanovaRegular\";font-size:16px\n}\n.amount-info .doller[data-v-eba1bad0]{color:rgba(33,33,33,0.9);font-family:\"ProximanovaRegular\";font-size:24px;margin-right:5px\n}\n.amount-info p[data-v-eba1bad0]{margin:5px 0\n}\n.amount-info p[data-v-eba1bad0]:nth-child(1){margin:10px 0\n}\n.amount-recived[data-v-eba1bad0]{color:rgba(33,33,33,0.9);font-family:\"ProximanovaBold\";font-size:20px;font-weight:bold;line-height:29px\n}\n.transactionandorderid[data-v-eba1bad0]{opacity:0.6;color:#212121;font-family:\"ProximanovaRegular\";font-size:16px;font-weight:500;line-height:24px\n}\n.success-price[data-v-eba1bad0]{color:#212121;font-family:\"ProximanovaBold\";font-size:26px;font-weight:bold;line-height:41px\n}\n.purchased-content[data-v-eba1bad0]{color:rgba(33,33,33,0.9);font-family:\"HelveticaNeueMedium\";font-size:24px;font-weight:bold;line-height:29px;text-transform:uppercase;margin:0 0 10px 0\n}\n.after-success[data-v-eba1bad0]{color:#212121;text-align:end;font-family:\"HelveticaNeueMedium\"\n}\n.after-success span[data-v-eba1bad0]{color:#d0021b;font-size:12px;font-weight:bold;line-height:19px\n}\n.succes-movie-title[data-v-eba1bad0]{color:rgba(33,33,33,0.9);font-family:\"HelveticaNeueMedium\";font-size:18px;font-weight:bold;line-height:23px\n}\n.purchased-content-image[data-v-eba1bad0]{margin-bottom:5%\n}\n.purchased-content-image div.outer[data-v-eba1bad0]{margin-top:5%;height:100%;text-align:center\n}\n.purchased-content-image div.outer img.contentImage[data-v-eba1bad0]{border-radius:5px;width:22%\n}\n.purchased-content-image p[data-v-eba1bad0]{color:#70787f;font-family:\"ProximanovaSemibold\";font-size:16px;font-weight:bold;text-align:center\n}\n.play[data-v-eba1bad0]{width:50px;position:relative;top:45%;left:45%\n}\n.quality-radio[data-v-eba1bad0]{margin-right:10px !important\n}\n.header-success-close[data-v-eba1bad0]{float:right;width:30px;cursor:pointer\n}\n.hrline[data-v-eba1bad0]{margin:3% 0;border-bottom:1px solid #acacac\n}\n.purchaseBtn .logo-container[data-v-eba1bad0]{background:#ffffff;padding:10px;width:30%;float:left;margin-left:5%;margin-right:4%\n}\n.purchaseBtn p[data-v-eba1bad0]{font-family:\"ProximanovaSemibold\";font-size:22px;float:left;font-weight:bold;margin-top:15px\n}\n.purchase-success[data-v-eba1bad0]{width:30px !important;height:30px !important;float:right;position:absolute;left:56%;margin-top:-10px;background-color:#6ac259;border-radius:50%\n}\n.purchase-success img[data-v-eba1bad0]{width:80%;margin-top:10%\n}\n.success-message[data-v-eba1bad0]{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6;border-radius:4px;text-align:center;padding:8px;margin-top:20px\n}\n.success-message p[data-v-eba1bad0]{font-size:20px\n}\n@media only screen and (max-width: 576px){\n.payment-popup .popup-box[data-v-eba1bad0]{min-width:250px\n}\n.payment-popup .box-header[data-v-eba1bad0]{padding:10px\n}\n.payment-popup .box-header h6[data-v-eba1bad0]{font-size:20px\n}\n.coupon-container[data-v-eba1bad0]{border:1px solid #bfbfbf;border-radius:6px;padding:5px 15px;margin:20px 0\n}\n.coupon-container .coupon[data-v-eba1bad0]{border:0;font-size:22px;min-height:30px;width:130%;background-color:transparent;color:#000;margin-top:5px;word-break:break-word\n}\n.coupon-container .coupon[data-v-eba1bad0]::-webkit-input-placeholder{opacity:0.4;color:#000;font-family:\"ProximanovaSemibold\";font-size:22px;font-weight:500;line-height:34px\n}\n.coupon-container .coupon[data-v-eba1bad0]:-ms-input-placeholder{opacity:0.4;color:#000;font-family:\"ProximanovaSemibold\";font-size:22px;font-weight:500;line-height:34px\n}\n.coupon-container .coupon[data-v-eba1bad0]::-ms-input-placeholder{opacity:0.4;color:#000;font-family:\"ProximanovaSemibold\";font-size:22px;font-weight:500;line-height:34px\n}\n.coupon-container .coupon[data-v-eba1bad0]::placeholder{opacity:0.4;color:#000;font-family:\"ProximanovaSemibold\";font-size:22px;font-weight:500;line-height:34px\n}\n.coupon-container .apply[data-v-eba1bad0]{text-transform:uppercase;color:#4558dd;font-family:\"ProximanovaBold\";font-size:22px;font-weight:bold;line-height:34px;cursor:pointer;margin-top:5px;text-align:end;opacity:0.85\n}\n.coupon-container .apply[data-v-eba1bad0]:hover{opacity:1\n}\n.payment-success[data-v-eba1bad0]{margin:2% 0;color:#1b1b1b;font-family:\"ProximanovaSemibold\";font-size:18px;font-weight:bold;margin:2% 20%;text-align:center\n}\n.purchase-success[data-v-eba1bad0]{width:20px !important;height:20px !important\n}\n}\n@media only screen and (min-width: 600px) and (max-width: 992px){\n.payment-popup .popup-box[data-v-eba1bad0]{min-width:500px\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 391:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAMFBMVEVHcEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlTPQ5AAAAD3RSTlMAf3f8FPET+xd4cXpvef0w819gAAAAYklEQVQ4y2NgGAXDAXDF/4eDrweQJJr/IwETJIk+XBLcyBIXkC3RR4h/RLGdCSEhgOoufewakLQIoHtFH7sGuBYBTN/rY9cA1SKALcD0sWsAaxHAHsbTK3EEPlvCaAKkEwAAXTx1ebcASmsAAAAASUVORK5CYII="

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAANlBMVEVHcEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAR2LVAAAAEXRSTlMAFHtw+/AVdon8ExcWfW13/eG/xXMAAABnSURBVEjH7dM5DoAwDETRAAlgtpD7XxYKhFjGiV0hJE/9vlzZOZvt7xsqne881Sqf9vVKrygOLy5OLywuXlTcvKB4+GLx8oUC+GwBfaaIidmMfUtcsI448FxAEz6xBOxDY+9us320DUH8EBjkLdY7AAAAAElFTkSuQmCC"

/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-popup"},[_c('div',{ref:"popupBox",staticClass:"popup-box",style:({ width: _vm.width, top: _vm.top })},[(!_vm.showSuccessPart)?_c('div',{staticClass:"box-header"},[_vm._t("header",[_c('h6',[_vm._v(_vm._s(_vm.header))])]),_vm._v(" "),_c('img',{staticClass:"header-close",attrs:{"src":__webpack_require__(84),"alt":"closes"},on:{"click":function($event){return _vm.closePopupCB()}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"session-exp-popup"},[(!_vm.showSuccessPart && _vm.paymentContent)?_c('div',{staticClass:"row",staticStyle:{"margin":"0"}},[_c('p',{staticClass:"summary"},[_vm._v("SUMMARY")]),_vm._v(" "),_c('div',{staticClass:"row mlmr0"},[_c('div',{staticClass:"col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 plpr0"},[_c('div',{staticClass:"movie-details"},[_c('p',{staticClass:"movie-title"},[_vm._v(_vm._s(_vm.paymentContent.title))])])]),_vm._v(" "),_c('div',{staticClass:"col-xlg-3 col-lg-3 col-md-3 col-sm-6 col-xs-6"}),_vm._v(" "),_c('div',{staticClass:"col-xlg-3 col-lg-3 col-md-3 col-sm-6 col-xs-6"},[_c('div',{staticClass:"price"},[_c('div',{staticClass:"price-info",staticStyle:{"cursor":"pointer"},on:{"click":_vm.togglePriceMenu}},[_c('img',{attrs:{"id":"pricearrow","src":_vm.iconArrowDown}})]),_vm._v(" "),(_vm.contentPrice)?_c('p',[_vm._v("\n                "+_vm._s(_vm.contentPrice.currencysymbol)+" "),_c('span',[_vm._v(_vm._s(_vm.price))])]):_vm._e()])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide"}},[(_vm.showPriceDetail)?_c('div',{staticClass:"row price-detail"},[_c('div',{staticClass:"col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"}),_vm._v(" "),_c('div',{staticClass:"col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"},[_c('div',{staticClass:"row price-detail"},[_c('div',{staticClass:"col-xlg-7 col-lg-7 col-md-7 col-sm-7 col-xs-7",staticStyle:{"padding-right":"0px"}},[_c('p',{staticClass:"amount-label"},[_vm._v("Item Price")]),_vm._v(" "),(_vm.discount)?_c('p',{staticClass:"amount-label"},[_vm._v("Discount")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xlg-5 col-lg-5 col-md-5 col-sm-5 col-xs-5",staticStyle:{"padding-left":"0px","padding-right":"0px"}},[_c('p',{staticClass:"amount-style"},[_vm._v("\n                    "+_vm._s(_vm.contentPrice.currencysymbol)+" "+_vm._s(_vm.accessFee)+"\n                  ")]),_vm._v(" "),(_vm.discount)?_c('p',{staticClass:"amount-style"},[_vm._v("\n                    "+_vm._s(_vm.contentPrice.currencysymbol)+" "+_vm._s(_vm.discount)+"\n                  ")]):_vm._e()])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mlmr0 coupon-container"},[_c('div',{staticClass:"col-xlg-8 col-lg-8 col-md-8 col-sm-6 col-xs-6"},[(_vm.showCouponInput)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.coupon),expression:"coupon"}],staticClass:"coupon",attrs:{"placeholder":"COUPON CODE","type":"text","width":"100%","maxlength":"12"},domProps:{"value":(_vm.coupon)},on:{"input":function($event){if($event.target.composing){ return; }_vm.coupon=$event.target.value}}}):_c('p',{staticClass:"coupon"},[_vm._v(_vm._s(_vm.coupon))])]),_vm._v(" "),_c('div',{staticClass:"col-xlg-4 col-lg-4 col-md-4 col-sm-6 col-xs-6"},[(_vm.showCouponInput)?_c('p',{staticClass:"apply",on:{"click":function($event){return _vm.verifyCoupon()}}},[_vm._v("\n              Apply\n            ")]):_c('p',{staticClass:"apply",on:{"click":function($event){return _vm.removeCoupon()}}},[_vm._v("Remove")])])]),_vm._v(" "),_c('div',{staticClass:"vlt-lgn-btns"},[(_vm.showProceedButton)?_c('button',{ref:"loginBtnSubmit",staticClass:"btn-lg-primary",attrs:{"type":"submit"},on:{"click":_vm.proceed}},[_c('p',[_vm._v("Proceed")])]):_vm._e(),_vm._v(" "),(_vm.showPaymentButton)?_c('div',{attrs:{"id":"paypal-button-container1"}}):_vm._e()])],1):_vm._e(),_vm._v(" "),(_vm.showSuccessPart && _vm.paymentContent)?_c('div',[_c('img',{staticClass:"header-close",attrs:{"src":__webpack_require__(84),"alt":"closes"},on:{"click":function($event){return _vm.closePopupCB()}}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"purchased-content-image"},[_c('div',{staticClass:"outer"},[_vm._m(1),_vm._v(" "),_c('img',{staticClass:"contentImage",attrs:{"width":"100%","height":"100%","src":_vm.getPoster(_vm.paymentContent, 'PORTRAIT')}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.paymentContent.title))])]),_vm._v(" "),_c('div',{staticClass:"hrline"}),_vm._v(" "),_c('div',{staticClass:"row mlmr0 success-info"},[_c('p',[_vm._v("Hi "+_vm._s(_vm.AppUser.subscribername)+",")]),_vm._v(" "),_c('p',[_vm._v("Congratulations!")]),_vm._v(" "),_c('p',[_vm._v("Your payment has been processed successfully")])]),_vm._v(" "),_c('div',{staticClass:"hrline"}),_vm._v(" "),_c('div',{staticClass:"row mlmr0 amount-info"},[_c('div',{staticClass:"col-xlg-8 col-lg-8 col-md-8 col-sm-8 col-xs-8 Gplpr0",staticStyle:{"padding-left":"0px"}},[_c('p',{staticClass:"amount-recived"},[_vm._v("Amount Received")]),_vm._v(" "),(_vm.transactionID)?_c('p',{staticClass:"transactionandorderid"},[_vm._v("\n              Transaction ID : "+_vm._s(_vm.transactionID)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.orderID)?_c('p',{staticClass:"transactionandorderid"},[_vm._v("\n              Order ID : "+_vm._s(_vm.orderID)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xlg-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('p',{staticStyle:{"text-align":"end"}},[_c('span',{staticClass:"doller"},[_vm._v(_vm._s(_vm.contentPrice.currencysymbol))]),_vm._v(" "),_c('span',{staticClass:"success-price"},[_vm._v(_vm._s(_vm.price))])])])])]):_vm._e(),_vm._v(" "),_c('FormError',{directives:[{name:"show",rawName:"v-show",value:(_vm.paymentError),expression:"paymentError"}],staticStyle:{"margin-top":"20px"},attrs:{"message":_vm.paymentError}}),_vm._v(" "),_c('Loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}]}),_vm._v(" "),(_vm.successMessage)?_c('div',{staticClass:"success-message"},[_c('p',[_vm._v(_vm._s(_vm.successMessage))])]):_vm._e()],1)]),_vm._v(" "),_vm._m(2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"payment-success"},[_vm._v("You have Successfully Purchased")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purchase-success"},[_c('img',{attrs:{"src":__webpack_require__(394)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup-overlay"},[_c('span')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 394:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNTJwdCIgaGVpZ2h0PSI1MnB0IiB2aWV3Qm94PSIwIDAgNTIgNTIiIHZlcnNpb249IjEuMSI+CjxnIGlkPSJzdXJmYWNlMjg1MDQ5Ij4KPHBhdGggc3R5bGU9IiBzdHJva2U6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztmaWxsOnJnYigxMDAlLDEwMCUsMTAwJSk7ZmlsbC1vcGFjaXR5OjE7IiBkPSJNIDQ1LjEzMjgxMiA5LjQ2MDkzOCBMIDQxLjU0Njg3NSA3LjAyMzQzOCBDIDQwLjU1NDY4OCA2LjM1MTU2MiAzOS4xOTUzMTIgNi42MDkzNzUgMzguNTMxMjUgNy41OTM3NSBMIDIwLjk1MzEyNSAzMy41MTU2MjUgTCAxMi44NzUgMjUuNDM3NSBDIDEyLjAzMTI1IDI0LjU5Mzc1IDEwLjY1NjI1IDI0LjU5Mzc1IDkuODEyNSAyNS40Mzc1IEwgNi43NDIxODggMjguNTA3ODEyIEMgNS44OTg0MzggMjkuMzUxNTYyIDUuODk4NDM4IDMwLjcyNjU2MiA2Ljc0MjE4OCAzMS41NzgxMjUgTCAxOS4xNjQwNjIgNDQgQyAxOS44NTkzNzUgNDQuNjk1MzEyIDIwLjk1MzEyNSA0NS4yMjY1NjIgMjEuOTM3NSA0NS4yMjY1NjIgQyAyMi45MjE4NzUgNDUuMjI2NTYyIDIzLjkxNDA2MiA0NC42MDkzNzUgMjQuNTU0Njg4IDQzLjY3OTY4OCBMIDQ1LjcxMDkzOCAxMi40Njg3NSBDIDQ2LjM4MjgxMiAxMS40ODQzNzUgNDYuMTI1IDEwLjEzMjgxMiA0NS4xMzI4MTIgOS40NjA5MzggWiBNIDQ1LjEzMjgxMiA5LjQ2MDkzOCAiLz4KPC9nPgo8L3N2Zz4K"

/***/ })

});


// WEBPACK FOOTER //
// static/js/30.2c1200b9d3b332ae2c23.js